<template>
<v-row>
  <v-col cols="12">
    <v-radio-group v-model="value.tipoInscricao" row 
      dense
      :disabled="!isNovoCadastro"
      :rules="rulesNovoCadastro([
        this.$validators.string.required,
      ])">
      <v-radio color="#efc00f"
        value="FOR">
        <template v-slot:label>
          Fornecedor
        </template>
      </v-radio>
      <v-radio color="#efc00f"
        value="COM">
        <template v-slot:label>
          Comprador
        </template>
      </v-radio>
    </v-radio-group>
  </v-col>
  <v-col cols="12" sm="6">
    <search-box v-show="value.tipoInscricao === 'FOR'"
        label="Fornecedor"
        :disabled="!isNovoCadastro"
        popup-label="Selecione um Fornecedor"
        :id.sync="value.idFornecedor"
        :nomeCompletoSemCnpj.sync="value.nomeCompletoFornecedor"
        :value="fornecedor"
        :loader-fn="loaderFornecedor"
        item-key="id"
        item-text="nomeCompletoSemCnpj">
      <template v-slot:empty>
        <p class="ma-2">
          Nenhum Fornecedor encontrado
        </p>
      </template>
    </search-box>
    <search-box v-show="value.tipoInscricao === 'COM'"
        label="Comprador"
        :disabled="!isNovoCadastro"
        popup-label="Selecione um Comprador"
        :id.sync="value.idComprador"
        :nomeCompletoSemCnpj.sync="value.nomeCompletoComprador"
        :value="comprador"
        :loader-fn="loaderComprador"
        item-key="id"
        item-text="nomeCompletoSemCnpj">
      <template v-slot:empty>
        <p class="ma-2">
          Nenhum Comprador encontrado
        </p>
      </template>
    </search-box>
  </v-col>
  <v-col cols="12" sm="6">
    <lookup-dominio label="* Status"
      :disabled="isNovoCadastro || statusAprovado"
      v-model="value.status"
      :type="lookups.status"
      :exclude-keys="statusKeysExcluidos"
      :hidden-clear="false"/>
  </v-col>
  <v-col cols="12" sm="6" v-if="exibeDataPagamento">
    <v-text-field label="* Data de Pagamento"
        dense
        type="date"
        v-model="value.dtPagamento"
        :rules="[
            this.$validators.string.required,
            v => this.$validators.string.lessThanOrEquals(v, 10)
        ]"/>
  </v-col>
  <v-col cols="12" sm="6" v-if="statusAprovado && !exibeDataPagamento">
    <v-text-field label="* Data de Pagamento"
        dense
        :disabled="true"
        type="date"
        v-model="value.dtPagamento"
        :rules="[
            this.$validators.string.required,
            v => this.$validators.string.lessThanOrEquals(v, 10)
        ]"/>
  </v-col>
  <v-col cols="12" sm="6" v-show="value.tipoInscricao !== ''">
    <search-box ref="comboEventos"
        :hidden-clear="true"
        :disabled="!isNovoCadastro"
        :emit-all-properties="true"
        label="* Edição do Evento"
        popup-label="Selecione uma Edição Ativa"
        :id.sync="value.idEventoEdicao"
        :descricao.sync="value.descEventoEdicao"
        :cronograma.sync="value.cronograma"
        :idEvento.sync="value.idEvento"
        :value="eventoEdicao"
        :loader-fn="loaderEventoEdicaoAtivas"
        item-key="id"
        item-text="descricao"
        :rules="rulesNovoCadastro([
              this.$validators.notNullOrUndefined
          ])">
      <template v-slot:empty>
        <p class="ma-2">
          Nenhuma Edição Ativa encontrada
        </p>
      </template>
    </search-box>
  </v-col>
  <v-col cols="12">
    <v-sheet class="inscricao-resumo pa-3" outlined rounded>
      <v-row dense>
        <v-col cols="12" sm="4" class="resumo-item">
          <div class="resumo-item__label">
            <v-icon small color="primary" class="mr-1">mdi-calendar-check</v-icon>
            Data da inscrição
          </div>
          <div class="resumo-item__valor">{{ dataInscricao }}</div>
        </v-col>
        <v-col cols="12" sm="8" class="resumo-item">
          <div class="resumo-item__label">
            <v-icon small color="primary" class="mr-1">mdi-ticket-confirmation-outline</v-icon>
            Inscrição
          </div>
          <div class="resumo-item__valor">{{ value.descTipoAcessoEventoEdicao }}{{ infoPagamento }}</div>
        </v-col>
      </v-row>
    </v-sheet>
  </v-col>  
  <v-col cols="12" v-if="cronogramasDisponiveis.length > 0">
    <div class="text-subtitle-2 mb-2">Cronograma da Edição</div>
    <div class="cronograma-lista">
      <div
        v-for="item in cronogramasDisponiveis"
        :key="item.id"
        class="cronograma-item"
        :class="{ 'cronograma-item--selecionado': cronogramaEstaSelecionado(item) }"
        @click="toggleCronograma(item)">
        <div class="cronograma-item__header">
          <v-icon small :color="cronogramaEstaSelecionado(item) ? 'success' : 'grey'">
            {{ cronogramaEstaSelecionado(item) ? 'mdi-checkbox-marked-circle' : 'mdi-checkbox-blank-circle-outline' }}
          </v-icon>
          <span class="font-weight-bold">{{ item.data | moment('DD/MM/YYYY') }}</span>
          <span class="ml-2">{{ item.horaInicio }} - {{ item.horaFim }}</span>
        </div>
        <div class="cronograma-item__descricao">{{ item.descricao }}</div>
      </div>
    </div>
  </v-col>
  <v-col cols="12">
    <search-box-multiple
        :label="`* ${getTextoOfertaDemanda}s disponíveis`"
        class="search-box-cursos"
        :disabled="!isNovoCadastro"
        :popup-label="`Clique no campo acima para visualizar as opções disponíveis e selecione as ${getTextoOfertaDemanda}s desejadas. Para filtrar mais resultados, digite parte do texto desejado.`"
        v-model="value.ofertaDemanda"
        :loader-fn="loaderOfertasDemandas"
        item-key="id"
        item-text="descricaoCompleta"
        :rules="rulesNovoCadastro([
              validarOfertaDemandaObrigatoria,
          ])">
      <template v-slot:selection="{item}" >
        <div class="curso-chip-wrap">
          <div @click.stop class="curso-chip v-chip">
            <v-icon class="mr-2" color="success" small>mdi-checkbox-marked-circle</v-icon>
            <div class="item-description">{{item.descricaoCompleta}}</div>
            <div v-show="isNovoCadastro" class="remove-button" @click="removeOfertaDemanda(item)">
              <v-btn x-small icon class="ma-0 pa-0">
                <v-icon>mdi-close-circle</v-icon>
              </v-btn>
            </div>
          </div>
        </div>
      </template>
      <template v-slot:empty>
        <p class="ma-2">
          Nenhuma {{ getTextoOfertaDemanda }} encontrada.
        </p>
      </template>
    </search-box-multiple>
  </v-col>
  <v-col cols="12">
    <v-textarea
      v-model="value.maisDetalhe"
      :disabled="!isNovoCadastro"
      :label="`Detalhe da(s) sua(s) ${getTextoOfertaDemanda} para o evento`"
      rows="4"
      :rules="rulesNovoCadastro([
            this.$validators.string.required,
            v => this.$validators.string.lessThanOrEquals(v, 4000)
          ])"
      outlined
    ></v-textarea>
  </v-col>  
</v-row>
</template>

<script>
import SearchBox from "../common/SearchBox";
import {findAllEventoEdicaoAtivas} from "../../../api/eventoEdicao";
import {findAll as findAllFornecedor} from "../../../api/fornecedor";
import {findAll as findAllComprador} from "../../../api/comprador";
import {findAll as findAllOferta} from "@/api/oferta";
import LookupDominio from "../common/LookupDominio";
import {ItemDeDominio} from "../../../api/itemsDominio";
import SearchBoxMultiple from "@/components/shared/common/SearchBoxMultiple";
import moment from 'moment';
import {mapGetters} from "vuex";

export default {
  name: "EventoInscricaoForm",
  components: {LookupDominio, SearchBox, SearchBoxMultiple},
  props: {
    value: {
      type: Object
    }
  },
  data () {
    return {
      lookups: {
        status: ItemDeDominio.STATUS_INSCRICAO
      },
      opcaoInscricao: null,
      statusAtual: this.value?.status || "",
      statusLocal: this.value.status
    }
  },
  computed: {
    ...mapGetters('auth',['user','isAuthenticated','nivelUsuarioLogado']),
    isAdm(){
      return this.nivelUsuarioLogado === 'ADM';
    },
    statusAprovado() {
      return this.statusLocal === "A" ? true : false
    },
    isNovoCadastro(){
      return !(this.value && 
             this.value.id !== null && 
             this.value.id !== undefined &&
             parseInt(this.value.id) > 0);
    },
    statusKeysExcluidos() {
      return this.statusAtual === 'L' ? [] : ['L'];
    },
    exibeDataPagamento() {
      return !this.isNovoCadastro
        && this.value.tipoAcessoEventoEdicao === 'P'
        && this.statusAtual === 'L'
        && this.value.status === 'A';
    },
    getTextoOfertaDemanda() {
      if (this.value.tipoInscricao === 'FOR') {
        return "Oferta";
      } else if (this.value.tipoInscricao === 'COM') {
        return "Demanda";
      } else {
        return "";
      }
    },    
    dataInscricao(){
      if (this.isNovoCadastro){
        return moment().format('DD/MM/YYYY');
      }
      return moment(this.value.dtInscricao).format('DD/MM/YYYY');
    },
    infoPagamento() {
      if (this.value.tipoAcessoEventoEdicao === 'P') {
        return ` - Valor: R$ ${this.value.valorInscricaoEdicao}. ${this.value.linkPagamento === '' ? 'link de pagamento não enviado' : 'link de pagamento enviado por email'}`;
      }
      return '';
    },    
    fornecedor() {
      if (this.value.idFornecedor == null) return null;
      return {
        id: this.value.idFornecedor,
        nomeCompletoSemCnpj: this.value.nomeCompletoFornecedor
      }
    },
    comprador() {
      if (this.value.idComprador == null) return null;
      return {
        id: this.value.idComprador,
        nomeCompletoSemCnpj: this.value.nomeCompletoComprador
      }
    },
    eventoEdicao() {
      if(this.value.idEventoEdicao == null) {
        this.value.descEventoEdicao = null;
        this.value.idEvento = null;
        this.value.cronograma = null;
        return null
      };
      return {
        id: this.value.idEventoEdicao,
        descricao: this.value.descEventoEdicao,
        idEvento: this.value.idEvento,
        cronograma: this.value.cronograma,
      }
    },
    cronogramasDisponiveis() {
      return Array.isArray(this.value.cronograma) ? this.value.cronograma : [];
    },
    cronogramasSelecionadosIds() {
      const selecionados = Array.isArray(this.value.cronogramaInscricao)
        ? this.value.cronogramaInscricao
        : [];
      return selecionados.map(item => Number(item.id));
    },
  },
  watch: {
    'value.tipoInscricao': {
      deep: true,
      handler(newValue, oldValue) {
        if (newValue !== oldValue) {
          this.value.idFornecedor = null;
          this.value.idComprador = null;
          this.recarregaComboEventoEdicaoAtivas();
        }
      }
    },
    'value.idComprador': {
      deep: true,
      handler(newValue, oldValue) {
        if (newValue !== oldValue && newValue !== null) {
          this.value.idFornecedor = null;
          this.recarregaComboEventoEdicaoAtivas();
        }
      }
    },
    'value.idFornecedor': {
      deep: true,
      handler(newValue, oldValue) {
        if (newValue !== oldValue && newValue !== null) {
          this.value.idComprador = null;
          this.recarregaComboEventoEdicaoAtivas();
        }
      }
    },
  },  
  methods: {
    rulesNovoCadastro(rules) {
      return this.isNovoCadastro ? rules : [];
    },
    recarregaComboEventoEdicaoAtivas() {
      this.$refs.comboEventos.resetValues();
      this.$refs.comboEventos.search();
    },
    loaderFornecedor(page, search) {
      return findAllFornecedor(page, {
        nome: search
      })
    },
    loaderComprador(page, search) {
      return findAllComprador(page, {
        nome: search
      })
    },
    loaderEventoEdicaoAtivas(page, search) {
      return findAllEventoEdicaoAtivas(page, {
        descricao: search,
        tipoInscricao: this.value.tipoInscricao,
        idComprador: this.value.idComprador,
        idFornecedor: this.value.idFornecedor
      })
    },
    loaderOfertasDemandas(page, search) {
      return findAllOferta(page, {
        descricao: search
      })
    }, 
    cronogramaEstaSelecionado(item) {
      return this.cronogramasSelecionadosIds.includes(Number(item.id));
    },
    toggleCronograma(item) {
      if (!this.isNovoCadastro) {
        return;
      }

      if (!Array.isArray(this.value.cronogramaInscricao)) {
        this.value.cronogramaInscricao = [];
      }

      const selecionado = this.cronogramaEstaSelecionado(item);
      if (selecionado) {
        this.value.cronogramaInscricao = this.value.cronogramaInscricao
          .filter(cronograma => Number(cronograma.id) !== Number(item.id));
        return;
      }

      this.value.cronogramaInscricao = [...this.value.cronogramaInscricao, item];
    },
    validarOfertaDemandaObrigatoria(value) {
      return Array.isArray(value) && value.length > 0
        ? true
        : `Selecione ao menos uma ${this.getTextoOfertaDemanda.toLowerCase()}.`;
    }, 
    removeOfertaDemanda(item) {
      this.value.ofertaDemanda = this.value.ofertaDemanda.filter(v => v.id !== item.id);
    },         
    configuraInscricao(){
      if (this.isNovoCadastro){
        this.value.status = 'E';
        this.value.tipoInscricao = !this.isAdm ? this.nivelUsuarioLogado : "";
        if (!this.isAdm){
          this.value.idContato = this.user.idResponsavel;
          if (this.nivelUsuarioLogado === 'FOR'){
            this.value.idFornecedor = this.user.id;
            this.value.nomeCompletoFornecedor = this.user.nome;
            this.value.idComprador = null;
            this.value.nomeCompletoComprador = "";
          } else if (this.nivelUsuarioLogado === 'COM'){
            this.value.idFornecedor = null;
            this.value.nomeCompletoFornecedor = "";
            this.value.idComprador = this.user.id;
            this.value.nomeCompletoComprador = this.user.nome;          
          }
        }
      }
    }
  },
  mounted() {
    this.configuraInscricao();
  }
}
</script>

<style scoped lang="scss">
.curso-chip {
  margin: 0 6px 0 0;
  padding-right: 0;
  cursor: initial;
  background-color: rgba(0,0,0,0.1);
  min-height: 32px;
  height: auto;
  border-radius: 16px;
  border: 1px solid #dedede;
  display: flex;
  justify-content: center;
  align-items: stretch;

  .item-description {
    min-width: 150px;
    max-width: none;
    white-space: nowrap;
    overflow: visible;
    text-overflow: clip;
    padding-right: 5px;
    padding-top: 6px;
    padding-bottom: 6px;
    line-height: 1.3;
  }
  .remove-button {
    min-height: 32px;
    cursor: pointer;
    background-color: rgba(0,0,0,0.2);
    border-left: 2px solid #dedede;
    padding: 5px 8px !important;
    display: flex;
    align-items: center;
    transition: background-color 0.5s ease 0s;
    &:hover {
      background-color: rgba(0,0,0,0.3);
    }
  }
}

.curso-chip-wrap {
  display: inline-flex;
  padding-top: 4px;
  padding-bottom: 4px;
}

.cronograma-lista {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.cronograma-item {
  border: 1px solid #d8d8d8;
  border-radius: 8px;
  padding: 10px;
  cursor: pointer;
  transition: background-color .2s ease, border-color .2s ease;
}

.cronograma-item:hover {
  background-color: #fafafa;
}

.cronograma-item--selecionado {
  border-color: #2eab66;
  background-color: #f1fbf5;
}

.cronograma-item__header {
  display: flex;
  align-items: center;
  gap: 6px;
}

.cronograma-item__descricao {
  margin-top: 4px;
  color: #555;
}

.inscricao-resumo {
  border-color: #dbe7f3 !important;
  background: linear-gradient(180deg, #f8fbff 0%, #ffffff 100%);
}

.resumo-item {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.resumo-item__label {
  display: flex;
  align-items: center;
  color: #54708c;
  font-size: 12px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.4px;
}

.resumo-item__valor {
  color: #1f2d3d;
  font-size: 15px;
  font-weight: 500;
  line-height: 1.4;
  word-break: break-word;
}

</style>